/**
 * PosicaoMotorista
 * @author Simpli CLI generator
 */
import {$, ID, Resource} from 'simpli-web-sdk'
import {
  ResponseSerialize,
  ValidationRequired,
} from 'simpli-web-sdk'
import Carga from '@/model/resource/Carga'
import Motorista from '@/model/resource/Motorista'
import PosicaoMotoristaSchema from '@/schema/PosicaoMotorista.schema'

export default class PosicaoMotorista extends Resource {
  readonly $name: string = 'PosicaoMotorista'

  readonly $endpoint: string = '/user/posicao-motorista{/id}'

  get $schema() {
    return PosicaoMotoristaSchema(this)
  }

  get $id() {
    return this.idPosicaoPk
  }
  set $id(val: ID) {
    this.idPosicaoPk = val
  }

  @ResponseSerialize(Carga)
  carga = new Carga()

  @ResponseSerialize(Motorista)
  motorista = new Motorista()

  idPosicaoPk: ID = 0

  @ValidationRequired()
  latitude: number = 0

  @ValidationRequired()
  longitude: number = 0

  customTrack: boolean = false

  enderecoAlternativo: string | null = null

  @ValidationRequired()
  data: string = ''

  distanciaParaDestinoEmMetros: number = 0

  duracaoParaDestinoEmSegundos: number = 0

  get idMotoristaFk() {
    if (!this.motorista) return 0
    return this.motorista.$id
  }
  set idMotoristaFk(idMotoristaFk: ID) {
    if (!this.motorista) this.motorista = new Motorista()
    this.motorista.$id = idMotoristaFk
  }

  get idCargaFk() {
    if (!this.carga) return 0
    return this.carga.$id
  }
  set idCargaFk(idCargaFk: ID) {
    if (!this.carga) this.carga = new Carga()
    this.carga.$id = idCargaFk
  }

  get distanciaParaDestinoKm() {
    return (this.distanciaParaDestinoEmMetros / 1000).toFixed(1)
  }

  get duracaoParaDestinoHora() {
    return (this.duracaoParaDestinoEmSegundos / 3600).toFixed(2)
  }

  async persistPosicaoMotorista(model?: PosicaoMotorista, spinner = 'persistPosicaoMotorista') {
    const fetch = async () => {
      if (model) await model.validate()
      return await this.POST(`/user/posicao-motorista`, model)
    }

    return await $.await.run(fetch, spinner)
  }

  async getPosicaoMotorista(id: number, spinner = 'getPosicaoMotorista') {
    const fetch = async () => await this.GET(`/user/posicao-motorista/${id}`)
    return await $.await.run(fetch, spinner)
  }

  async updateDistanceTo(spinner = 'updateDistanceTo') {
    const fetch = async () => await this.POST(`/user/posicao-motorista/${this.idPosicaoPk}/distancia`)
    return await $.await.run(fetch, spinner)
  }
}
